/// <reference types="@angular/localize" />
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideToastr } from 'ngx-toastr';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { DatePipe } from '@angular/common';
// import { jwtInterceptor } from './app/interceptors/jwt.interceptor';
import { jwtInterceptor } from './app/_helpers';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
    }),
    provideHttpClient(
      withInterceptors([jwtInterceptor])
    ),
    DatePipe,
  ],
}).catch((err) => console.error(err));
